/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ApiRequestTrackedRouteModel } from '../model/models';
import { ApiResponseUnseenActivityTripAndTransactionModel } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface PaveGpsTrackingServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     * @param apiRequestTrackedRouteModel 
     */
    paveGPSTrackingControllerSave0(apiRequestTrackedRouteModel: ApiRequestTrackedRouteModel, extraHttpRequestParams?: any): Observable<ApiResponseUnseenActivityTripAndTransactionModel>;

    /**
     * 
     * 
     * @param apiRequestTrackedRouteModel 
     */
    paveGPSTrackingControllerSave1(apiRequestTrackedRouteModel: ApiRequestTrackedRouteModel, extraHttpRequestParams?: any): Observable<ApiResponseUnseenActivityTripAndTransactionModel>;

}
